<template>
  <div>
    <!-- Button trigger modal -->
    <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal">
      Create New Experiment
    </button>

    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Create new experiment</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <experiment-form v-on:variants-change="variantChange"></experiment-form>
          </div>
          <div class="modal-footer pt-3" style="border-top:1px solid rgba(0,0,0,0.1)">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" id="close">Close</button>
            <button type="button" class="btn btn-primary" @click="createExperiment" :disabled="createDisabled">Create experiment</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExperimentForm from './ExperimentForm'
export default {
  components: {
    ExperimentForm
  },
  data() {
    return {
      createDisabled: true
    }
  },
  methods: {
    createExperiment() {
      this.$emit('createExperiment')
    },
    variantChange(value) {
      this.createDisabled = value < 2
    }
  }
}
</script>
